export interface TrendingItem {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  coverUrl: string;
  stats: { label: string; value: string }[];
  position: number;
  trendDirection: 'up' | 'down' | 'stable';
  trendValue: string;
  score: number;
  link: string;
  tags: string[];
}

export interface TrendingCategory {
  id: string;
  name: string;
  icon: string;
  color: string;
  description: string;
  totalItems: number;
  items: TrendingItem[];
}

export interface ContentBlock {
  id: string;
  name: string;
  icon: string;
  color: string;
  description: string;
  items: ContentBlockItem[];
}

export interface ContentBlockItem {
  id: number;
  title: string;
  description: string;
  imageUrl: string;
  metric: string;
  metricValue: number;
  metricLabel: string;
  position: number;
  link: string;
  category: string;
}

export const trendingCategories: TrendingCategory[] = [
  {
    id: 'radios',
    name: 'Radios Tendencia',
    icon: 'ri-radio-line',
    color: 'text-rose-600',
    description: 'Las emisoras que están marcando la pauta ahora mismo en toda la comunidad RFW.',
    totalItems: 847,
    items: [
      {
        id: 1,
        name: 'La Mega 107.3 FM',
        description: 'La emisora urbana más escuchada del Caribe con programación 24/7 y los mejores DJs en vivo.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20radio%20studio%20with%20warm%20amber%20lighting%2C%20professional%20broadcast%20equipment%2C%20sleek%20dark%20wood%20desk%2C%20sound%20panels%20on%20walls%2C%20editorial%20photography%20style%2C%20clean%20background%2C%20warm%20tones&width=400&height=400&seq=trending-radio-mega&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Warm%20amber%20radio%20station%20exterior%20at%20night%2C%20urban%20city%20lights%2C%20glowing%20signs%2C%20professional%20broadcast%20building%2C%20atmospheric%20moody%20lighting%2C%20cinematic%20composition%2C%20rich%20golden%20tones&width=800&height=300&seq=trending-cover-mega&orientation=landscape',
        stats: [
          { label: 'Oyentes', value: '142.8K' },
          { label: 'Programas', value: '18' },
          { label: 'Score RFW', value: '94.2' },
        ],
        position: 1,
        trendDirection: 'up',
        trendValue: '+12.4%',
        score: 94.2,
        link: '/radio/la-mega-107-3',
        tags: ['Urbano', 'Reggaetón', 'Tropical'],
      },
      {
        id: 2,
        name: 'Rock Nacional 98.1 FM',
        description: 'El hogar del rock en español con 20 años al aire. Entrevistas exclusivas y sesiones en vivo.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Rock%20radio%20station%20studio%20with%20electric%20guitars%20on%20wall%2C%20vintage%20warm%20lighting%2C%20brick%20wall%20background%2C%20professional%20microphone%20setup%2C%20edgy%20creative%20atmosphere%2C%20editorial%20style%20shot&width=400&height=400&seq=trending-radio-rock&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Gritty%20urban%20radio%20station%20building%20with%20neon%20signs%2C%20industrial%20architecture%2C%20night%20time%20cityscape%2C%20warm%20amber%20street%20lights%2C%20cinematic%20mood%2C%20rock%20culture%20vibes&width=800&height=300&seq=trending-cover-rock&orientation=landscape',
        stats: [
          { label: 'Oyentes', value: '98.3K' },
          { label: 'Programas', value: '14' },
          { label: 'Score RFW', value: '91.7' },
        ],
        position: 2,
        trendDirection: 'up',
        trendValue: '+8.1%',
        score: 91.7,
        link: '/radio/rock-nacional-98-1',
        tags: ['Rock', 'Alternativo', 'Entrevistas'],
      },
      {
        id: 3,
        name: 'Radio Clásica 92.5 FM',
        description: 'Música clásica y cultura. La radio que eleva el alma con las mejores sinfonías y ópera en vivo.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20radio%20studio%20with%20grand%20piano%2C%20warm%20golden%20lighting%2C%20sophisticated%20interior%20design%2C%20wood%20paneling%2C%20professional%20broadcast%20microphone%2C%20refined%20atmosphere%2C%20editorial%20photography&width=400&height=400&seq=trending-radio-clasica&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20architecture%20building%20with%20warm%20interior%20lighting%20visible%20through%20tall%20windows%2C%20symphony%20hall%20exterior%2C%20sophisticated%20nighttime%20scene%2C%20golden%20tones%2C%20cultural%20landmark&width=800&height=300&seq=trending-cover-clasica&orientation=landscape',
        stats: [
          { label: 'Oyentes', value: '76.5K' },
          { label: 'Programas', value: '12' },
          { label: 'Score RFW', value: '89.3' },
        ],
        position: 3,
        trendDirection: 'up',
        trendValue: '+6.7%',
        score: 89.3,
        link: '/radio/radio-clasica-92-5',
        tags: ['Clásica', 'Ópera', 'Cultural'],
      },
      {
        id: 4,
        name: 'Tropicalísima 105.7 FM',
        description: 'Salsa, merengue y bachata las 24 horas. La emisora que te hace bailar sin parar.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20tropical%20radio%20studio%20with%20colorful%20Caribbean%20decor%2C%20warm%20sunset%20lighting%2C%20percussion%20instruments%2C%20festive%20atmosphere%2C%20professional%20broadcast%20setup%2C%20editorial%20style%2C%20rich%20warm%20colors&width=400&height=400&seq=trending-radio-tropical&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Colorful%20Caribbean%20style%20building%20at%20sunset%2C%20tropical%20palm%20trees%2C%20warm%20golden%20hour%20light%2C%20festive%20exterior%20with%20string%20lights%2C%20beach%20town%20atmosphere%2C%20vibrant%20architecture&width=800&height=300&seq=trending-cover-tropical&orientation=landscape',
        stats: [
          { label: 'Oyentes', value: '112.1K' },
          { label: 'Programas', value: '16' },
          { label: 'Score RFW', value: '92.8' },
        ],
        position: 4,
        trendDirection: 'up',
        trendValue: '+9.2%',
        score: 92.8,
        link: '/radio/tropicalisima-105-7',
        tags: ['Salsa', 'Merengue', 'Bachata'],
      },
    ],
  },
  {
    id: 'locutores',
    name: 'Locutores Tendencia',
    icon: 'ri-mic-line',
    color: 'text-amber-600',
    description: 'Las voces que están dominando la conversación y ganando más seguidores en la comunidad.',
    totalItems: 1256,
    items: [
      {
        id: 10,
        name: 'Alejandro "El Lobo" Mendoza',
        description: '20 años frente al micrófono. Su programa matutino es el más escuchado del país con entrevistas que hacen noticia.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Charismatic%20male%20radio%20host%20in%20professional%20studio%2C%20warm%20amber%20lighting%2C%20expressive%20personality%2C%20silver%20hair%2C%20wearing%20headphones%2C%20engaging%20with%20microphone%2C%20editorial%20portrait%20style%2C%20warm%20neutral%20background&width=400&height=400&seq=trending-locutor-lobo&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Professional%20radio%20broadcast%20studio%20interior%2C%20warm%20atmospheric%20lighting%2C%20sound%20proof%20panels%2C%20modern%20mixing%20desk%2C%20professional%20environment%2C%20cinematic%20wide%20shot%2C%20golden%20hour%20tones&width=800&height=300&seq=trending-cover-lobo&orientation=landscape',
        stats: [
          { label: 'Seguidores', value: '31.2K' },
          { label: 'Programas', value: '3' },
          { label: 'Score RFW', value: '96.8' },
        ],
        position: 1,
        trendDirection: 'up',
        trendValue: '+15.3%',
        score: 96.8,
        link: '/host/alejandro-el-lobo-mendoza',
        tags: ['Matutino', 'Entrevistas', 'Noticias'],
      },
      {
        id: 11,
        name: 'Valentina Ríos',
        description: 'La voz femenina más influyente de la radio latina. Su estilo fresco y auténtico conquistó a toda una generación.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Confident%20young%20female%20radio%20host%20with%20warm%20smile%2C%20modern%20studio%20setting%2C%20natural%20amber%20lighting%2C%20professional%20headphones%2C%20engaging%20expression%2C%20editorial%20portrait%20photography%2C%20clean%20warm%20background&width=400&height=400&seq=trending-locutor-valentina&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20creative%20radio%20studio%20workspace%2C%20warm%20golden%20lighting%20through%20large%20windows%2C%20plants%20and%20contemporary%20decor%2C%20professional%20broadcast%20equipment%2C%20inviting%20atmosphere%2C%20wide%20cinematic%20shot&width=800&height=300&seq=trending-cover-valentina&orientation=landscape',
        stats: [
          { label: 'Seguidores', value: '28.7K' },
          { label: 'Programas', value: '2' },
          { label: 'Score RFW', value: '95.1' },
        ],
        position: 2,
        trendDirection: 'up',
        trendValue: '+18.9%',
        score: 95.1,
        link: '/host/valentina-rios',
        tags: ['Juvenil', 'Música', 'Cultura Pop'],
      },
      {
        id: 12,
        name: 'Carlos "El Maestro" Vega',
        description: 'Periodista y locutor con 30 años de trayectoria. Su análisis político es referencia obligada cada mañana.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Distinguished%20older%20male%20radio%20journalist%2C%20silver%20hair%20and%20glasses%2C%20professional%20studio%20environment%2C%20warm%20amber%20lighting%2C%20serious%20but%20warm%20expression%2C%20editorial%20portrait%20style%2C%20refined%20atmosphere&width=400&height=400&seq=trending-locutor-maestro&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Traditional%20radio%20broadcast%20studio%20with%20bookshelves%20and%20warm%20lighting%2C%20classic%20professional%20environment%2C%20wood%20paneling%2C%20vintage%20microphones%2C%20scholarly%20atmosphere%2C%20cinematic%20wide%20angle&width=800&height=300&seq=trending-cover-maestro&orientation=landscape',
        stats: [
          { label: 'Seguidores', value: '24.5K' },
          { label: 'Programas', value: '4' },
          { label: 'Score RFW', value: '93.4' },
        ],
        position: 3,
        trendDirection: 'up',
        trendValue: '+5.8%',
        score: 93.4,
        link: '/host/carlos-el-maestro-vega',
        tags: ['Periodismo', 'Política', 'Análisis'],
      },
      {
        id: 13,
        name: 'Diana Fuentes',
        description: 'La reina de las tardes. Su voz cálida y su selección musical la convirtieron en la favorita del público.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20friendly%20female%20radio%20host%20with%20genuine%20smile%2C%20afternoon%20light%20in%20modern%20studio%2C%20relaxed%20atmosphere%2C%20professional%20headphones%20around%20neck%2C%20editorial%20portrait%2C%20soft%20amber%20tones%2C%20approachable%20vibe&width=400&height=400&seq=trending-locutor-diana&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Cozy%20radio%20studio%20with%20warm%20afternoon%20sunlight%20streaming%20through%20windows%2C%20plants%20and%20soft%20furnishings%2C%20relaxed%20professional%20atmosphere%2C%20modern%20equipment%2C%20inviting%20creative%20space%2C%20cinematic%20wide%20shot&width=800&height=300&seq=trending-cover-diana&orientation=landscape',
        stats: [
          { label: 'Seguidores', value: '19.8K' },
          { label: 'Programas', value: '1' },
          { label: 'Score RFW', value: '91.2' },
        ],
        position: 4,
        trendDirection: 'up',
        trendValue: '+11.4%',
        score: 91.2,
        link: '/host/diana-fuentes',
        tags: ['Vespertino', 'Música', 'Entretenimiento'],
      },
    ],
  },
  {
    id: 'programas',
    name: 'Programas Tendencia',
    icon: 'ri-radio-line',
    color: 'text-emerald-600',
    description: 'Los programas que están generando más interacción, comentarios y fidelidad de audiencia.',
    totalItems: 2341,
    items: [
      {
        id: 20,
        name: 'El Despertador Nacional',
        description: 'El morning show número uno. Noticias, entrevistas, tráfico y el mejor humor para arrancar el día.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20morning%20radio%20show%20studio%20with%20coffee%20cups%20and%20newspapers%2C%20warm%20sunrise%20lighting%2C%20energetic%20atmosphere%2C%20professional%20broadcast%20setup%2C%20multiple%20hosts%20setting%2C%20editorial%20photography%2C%20golden%20morning%20tones&width=400&height=400&seq=trending-prog-despertador&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Bright%20morning%20radio%20studio%20with%20floor%20to%20ceiling%20windows%20showing%20sunrise%20city%20skyline%2C%20warm%20golden%20light%20flooding%20the%20space%2C%20professional%20broadcast%20equipment%2C%20energetic%20productive%20atmosphere%2C%20cinematic%20wide%20shot&width=800&height=300&seq=trending-cover-despertador&orientation=landscape',
        stats: [
          { label: 'Audiencia', value: '187.3K' },
          { label: 'Horario', value: '6-10 AM' },
          { label: 'Score RFW', value: '97.5' },
        ],
        position: 1,
        trendDirection: 'up',
        trendValue: '+8.7%',
        score: 97.5,
        link: '/program/el-despertador-nacional',
        tags: ['Matutino', 'Noticias', 'Variedades'],
      },
      {
        id: 21,
        name: 'Tardes de Café',
        description: 'El programa perfecto para la media tarde. Buena música, tertulia y los temas que importan.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20afternoon%20radio%20program%20scene%20with%20coffee%20cup%20and%20pastries%2C%20warm%20soft%20lighting%2C%20relaxed%20studio%20atmosphere%2C%20acoustic%20guitar%20nearby%2C%20intimate%20setting%2C%20editorial%20style%2C%20golden%20hour%20glow&width=400&height=400&seq=trending-prog-cafe&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Relaxed%20cafe%20style%20radio%20studio%20with%20warm%20afternoon%20sunlight%2C%20modern%20cozy%20interior%2C%20sofas%20and%20plants%2C%20professional%20microphones%2C%20inviting%20atmosphere%20with%20coffee%20culture%20vibes%2C%20cinematic%20wide%20shot&width=800&height=300&seq=trending-cover-cafe&orientation=landscape',
        stats: [
          { label: 'Audiencia', value: '134.6K' },
          { label: 'Horario', value: '3-6 PM' },
          { label: 'Score RFW', value: '93.8' },
        ],
        position: 2,
        trendDirection: 'up',
        trendValue: '+14.2%',
        score: 93.8,
        link: '/program/tardes-de-cafe',
        tags: ['Vespertino', 'Música', 'Tertulia'],
      },
      {
        id: 22,
        name: 'Noche de Leyendas',
        description: 'Historias de músicos legendarios, anécdotas del rock y sesiones acústicas exclusivas cada noche.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Moody%20evening%20radio%20show%20studio%20with%20vinyl%20records%20and%20warm%20amber%20lighting%2C%20intimate%20atmosphere%2C%20professional%20microphone%2C%20vintage%20audio%20equipment%2C%20rich%20dark%20tones%2C%20editorial%20photography%2C%20nostalgic%20vibe&width=400&height=400&seq=trending-prog-leyendas&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Atmospheric%20radio%20studio%20at%20night%20with%20city%20lights%20visible%20through%20windows%2C%20warm%20amber%20interior%20lighting%2C%20vintage%20decor%20with%20record%20collection%2C%20intimate%20moody%20setting%2C%20cinematic%20wide%20shot%20with%20deep%20shadows&width=800&height=300&seq=trending-cover-leyendas&orientation=landscape',
        stats: [
          { label: 'Audiencia', value: '98.2K' },
          { label: 'Horario', value: '9 PM-12 AM' },
          { label: 'Score RFW', value: '95.6' },
        ],
        position: 3,
        trendDirection: 'up',
        trendValue: '+22.1%',
        score: 95.6,
        link: '/program/noche-de-leyendas',
        tags: ['Nocturno', 'Rock', 'Historias'],
      },
      {
        id: 23,
        name: 'Fin de Semana Total',
        description: 'El programa que domina sábados y domingos. Sorteos, invitados especiales y la mejor energía.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Energetic%20weekend%20radio%20show%20with%20colorful%20decorations%2C%20bright%20warm%20lighting%2C%20multiple%20host%20setup%2C%20festive%20studio%20atmosphere%2C%20professional%20broadcast%20equipment%2C%20lively%20editorial%20photography%2C%20vibrant%20tones&width=400&height=400&seq=trending-prog-fin-semana&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20radio%20studio%20decorated%20for%20weekend%20show%2C%20balloons%20and%20streamers%2C%20warm%20natural%20light%2C%20festive%20professional%20atmosphere%2C%20modern%20broadcast%20equipment%2C%20energetic%20vibe%2C%20cinematic%20wide%20shot&width=800&height=300&seq=trending-cover-fin-semana&orientation=landscape',
        stats: [
          { label: 'Audiencia', value: '156.9K' },
          { label: 'Horario', value: '10 AM-2 PM' },
          { label: 'Score RFW', value: '92.1' },
        ],
        position: 4,
        trendDirection: 'up',
        trendValue: '+5.3%',
        score: 92.1,
        link: '/program/fin-de-semana-total',
        tags: ['Fin de Semana', 'Sorteos', 'Entretenimiento'],
      },
    ],
  },
  {
    id: 'clubes',
    name: 'Clubes Tendencia',
    icon: 'ri-group-line',
    color: 'text-violet-600',
    description: 'Las comunidades de fans más activas, con más miembros y mayor engagement en la plataforma.',
    totalItems: 452,
    items: [
      {
        id: 30,
        name: 'Legión de la Mega',
        description: 'El club oficial de fans de La Mega. Más de 12,000 miembros fieles que viven la radio al máximo.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Energetic%20fan%20club%20community%20gathering%20with%20warm%20lighting%2C%20concert%20atmosphere%2C%20crowd%20energy%2C%20urban%20music%20culture%2C%20vibrant%20colors%2C%20editorial%20photography%2C%20sense%20of%20belonging%20and%20excitement&width=400&height=400&seq=trending-club-legion&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Massive%20crowd%20at%20outdoor%20concert%20event%2C%20warm%20golden%20hour%20lighting%2C%20hands%20raised%2C%20energetic%20festival%20atmosphere%2C%20urban%20music%20scene%2C%20community%20gathering%2C%20cinematic%20wide%20shot%20with%20beautiful%20sky&width=800&height=300&seq=trending-cover-legion&orientation=landscape',
        stats: [
          { label: 'Miembros', value: '12.4K' },
          { label: 'Actividad', value: 'Muy Alta' },
          { label: 'Score RFW', value: '98.1' },
        ],
        position: 1,
        trendDirection: 'up',
        trendValue: '+24.8%',
        score: 98.1,
        link: '/clubes',
        tags: ['Premium', 'Urbano', 'Exclusivo'],
      },
      {
        id: 31,
        name: 'Rockeros Unidos',
        description: 'La comunidad rockera más grande de la plataforma. Intercambio de playlists, conciertos y debates.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Rock%20music%20fan%20community%20gathering%20with%20guitars%2C%20denim%20jackets%2C%20warm%20amber%20lighting%2C%20concert%20wristbands%2C%20intimate%20venue%20atmosphere%2C%20editorial%20photography%2C%20raw%20authentic%20energy&width=400&height=400&seq=trending-club-rockeros&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Rock%20concert%20crowd%20from%20behind%20stage%20view%2C%20warm%20amber%20spotlights%2C%20sea%20of%20raised%20hands%2C%20electric%20atmosphere%2C%20authentic%20rock%20venue%2C%20cinematic%20wide%20shot%20with%20dramatic%20lighting%20and%20haze&width=800&height=300&seq=trending-cover-rockeros&orientation=landscape',
        stats: [
          { label: 'Miembros', value: '9.8K' },
          { label: 'Actividad', value: 'Alta' },
          { label: 'Score RFW', value: '94.7' },
        ],
        position: 2,
        trendDirection: 'up',
        trendValue: '+18.3%',
        score: 94.7,
        link: '/clubes',
        tags: ['Rock', 'Conciertos', 'Playlists'],
      },
      {
        id: 32,
        name: 'Clásicos de Siempre',
        description: 'Para los amantes de la música clásica. Discusiones de sinfonías, recomendaciones y conciertos.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20music%20enthusiasts%20gathering%2C%20warm%20golden%20lighting%2C%20sophisticated%20atmosphere%2C%20champagne%20glasses%2C%20sheet%20music%2C%20cultured%20environment%2C%20editorial%20photography%2C%20refined%20aesthetic&width=400&height=400&seq=trending-club-clasicos&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Ornate%20symphony%20hall%20interior%20with%20warm%20golden%20lighting%2C%20empty%20stage%20with%20grand%20piano%2C%20elegant%20architecture%2C%20sophisticated%20atmosphere%2C%20cultural%20venue%2C%20cinematic%20wide%20shot%20with%20dramatic%20shadows&width=800&height=300&seq=trending-cover-clasicos&orientation=landscape',
        stats: [
          { label: 'Miembros', value: '6.2K' },
          { label: 'Actividad', value: 'Media-Alta' },
          { label: 'Score RFW', value: '91.3' },
        ],
        position: 3,
        trendDirection: 'up',
        trendValue: '+31.6%',
        score: 91.3,
        link: '/clubes',
        tags: ['Clásica', 'Cultural', 'Conciertos'],
      },
      {
        id: 33,
        name: 'Bailadores VIP',
        description: 'El club de los que aman la salsa, el merengue y la bachata. Eventos presenciales y clases exclusivas.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20Latin%20dance%20club%20scene%20with%20warm%20colorful%20lighting%2C%20couples%20dancing%20salsa%2C%20energetic%20festive%20atmosphere%2C%20tropical%20vibes%2C%20editorial%20photography%2C%20rich%20warm%20colors%2C%20joyful%20celebration&width=400&height=400&seq=trending-club-bailadores&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Tropical%20dance%20hall%20interior%20with%20colorful%20warm%20lighting%2C%20polished%20wooden%20dance%20floor%2C%20Latin%20music%20culture%20atmosphere%2C%20festive%20decor%2C%20professional%20venue%2C%20cinematic%20wide%20shot%20with%20vibrant%20energy&width=800&height=300&seq=trending-cover-bailadores&orientation=landscape',
        stats: [
          { label: 'Miembros', value: '8.1K' },
          { label: 'Actividad', value: 'Alta' },
          { label: 'Score RFW', value: '93.5' },
        ],
        position: 4,
        trendDirection: 'up',
        trendValue: '+27.4%',
        score: 93.5,
        link: '/clubes',
        tags: ['Salsa', 'Baile', 'Eventos'],
      },
    ],
  },
  {
    id: 'eventos',
    name: 'Eventos Tendencia',
    icon: 'ri-calendar-event-line',
    color: 'text-sky-600',
    description: 'Los eventos que están generando más expectativa, confirmaciones y conversación en la comunidad.',
    totalItems: 189,
    items: [
      {
        id: 40,
        name: 'RFW Fest 2026',
        description: 'El festival anual de RadioFrecuenciaWEB. 3 días de música en vivo, 50 artistas, food trucks y experiencias únicas.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Massive%20outdoor%20music%20festival%20with%20warm%20sunset%20lighting%2C%20multiple%20stages%2C%20colorful%20lights%2C%20festive%20crowd%2C%20summer%20atmosphere%2C%20editorial%20photography%2C%20vibrant%20celebration%20scene%2C%20wide%20festival%20view&width=400&height=400&seq=trending-evento-fest&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Epic%20music%20festival%20grounds%20at%20golden%20hour%2C%20main%20stage%20with%20massive%20LED%20screens%2C%20sea%20of%20festival%20goers%2C%20warm%20sunset%20sky%2C%20concert%20atmosphere%2C%20cinematic%20wide%20shot%2C%20vibrant%20energy%20and%20excitement&width=800&height=300&seq=trending-cover-fest&orientation=landscape',
        stats: [
          { label: 'Interesados', value: '24.6K' },
          { label: 'Confirman', value: '8.2K' },
          { label: 'Score RFW', value: '99.2' },
        ],
        position: 1,
        trendDirection: 'up',
        trendValue: '+42.7%',
        score: 99.2,
        link: '/eventos',
        tags: ['Festival', 'Música', 'Presencial'],
      },
      {
        id: 41,
        name: 'Noche de Estrellas de la Radio',
        description: 'Premiación anual a lo mejor de la radio. Alfombra roja, presentaciones en vivo y reconocimientos.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Glamorous%20radio%20awards%20ceremony%20with%20warm%20golden%20lighting%2C%20elegant%20venue%2C%20red%20carpet%20atmosphere%2C%20sophisticated%20gala%20event%2C%20editorial%20photography%2C%20sparkling%20ambiance%2C%20celebrity%20style&width=400&height=400&seq=trending-evento-estrellas&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Luxurious%20awards%20ceremony%20venue%20with%20golden%20warm%20lighting%2C%20elegant%20ballroom%20setting%2C%20stage%20with%20large%20screen%2C%20sophisticated%20gala%20atmosphere%2C%20chandeliers%2C%20cinematic%20wide%20shot%2C%20prestigious%20event&width=800&height=300&seq=trending-cover-estrellas&orientation=landscape',
        stats: [
          { label: 'Interesados', value: '18.3K' },
          { label: 'Confirman', value: '5.6K' },
          { label: 'Score RFW', value: '96.4' },
        ],
        position: 2,
        trendDirection: 'up',
        trendValue: '+35.1%',
        score: 96.4,
        link: '/eventos',
        tags: ['Premiación', 'Gala', 'Especial'],
      },
      {
        id: 42,
        name: 'Torneo de Clubes RFW',
        description: 'Competencia entre clubes de fans. Trivias, retos y batallas musicales por el trofeo anual.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Exciting%20club%20competition%20event%20with%20warm%20lighting%2C%20teams%20competing%2C%20gaming%20atmosphere%2C%20trophy%20display%2C%20energetic%20crowd%2C%20editorial%20photography%2C%20competitive%20spirit%2C%20vibrant%20colors&width=400&height=400&seq=trending-evento-torneo&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Large%20indoor%20arena%20set%20up%20for%20club%20competition%2C%20warm%20dramatic%20lighting%2C%20stage%20with%20big%20screens%2C%20excited%20audience%2C%20competitive%20gaming%20atmosphere%2C%20cinematic%20wide%20shot%2C%20electric%20energy&width=800&height=300&seq=trending-cover-torneo&orientation=landscape',
        stats: [
          { label: 'Interesados', value: '12.1K' },
          { label: 'Confirman', value: '4.8K' },
          { label: 'Score RFW', value: '92.8' },
        ],
        position: 3,
        trendDirection: 'up',
        trendValue: '+28.9%',
        score: 92.8,
        link: '/eventos',
        tags: ['Competencia', 'Clubes', 'Interactivo'],
      },
      {
        id: 43,
        name: 'Concierto Exclusivo: La Mega Live',
        description: 'Concierto privado para los miembros del club Legión de la Mega. Artistas sorpresa y meet & greet.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Intimate%20exclusive%20concert%20with%20warm%20amber%20stage%20lighting%2C%20small%20venue%20atmosphere%2C%20close%20crowd%20energy%2C%20live%20band%20performance%2C%20editorial%20photography%2C%20premium%20event%20feel%2C%20golden%20tones&width=400&height=400&seq=trending-evento-concierto&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Exclusive%20intimate%20concert%20venue%20with%20warm%20amber%20lighting%2C%20stage%20set%20up%20for%20live%20performance%2C%20premium%20atmosphere%2C%20small%20capacity%20venue%2C%20sophisticated%20lighting%20design%2C%20cinematic%20wide%20shot&width=800&height=300&seq=trending-cover-concierto&orientation=landscape',
        stats: [
          { label: 'Interesados', value: '15.7K' },
          { label: 'Confirman', value: '6.3K' },
          { label: 'Score RFW', value: '95.1' },
        ],
        position: 4,
        trendDirection: 'up',
        trendValue: '+19.5%',
        score: 95.1,
        link: '/eventos',
        tags: ['Concierto', 'Exclusivo', 'Club'],
      },
    ],
  },
  {
    id: 'concursos',
    name: 'Concursos Tendencia',
    icon: 'ri-trophy-line',
    color: 'text-orange-600',
    description: 'Los concursos con más participación, premios atractivos y mayor viralidad en la plataforma.',
    totalItems: 312,
    items: [
      {
        id: 50,
        name: 'La Voz de tu Ciudad',
        description: 'El concurso de talento vocal más grande. Ganá $5,000 USD, grabación profesional y gira promocional.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20competition%20stage%20with%20warm%20golden%20spotlight%2C%20microphone%20stand%20center%20stage%2C%20dramatic%20lighting%2C%20professional%20production%2C%20editorial%20photography%2C%20aspirational%20atmosphere%2C%20rich%20contrast&width=400&height=400&seq=trending-concurso-voz&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Grand%20talent%20show%20stage%20with%20dramatic%20warm%20lighting%2C%20golden%20spotlights%2C%20large%20audience%20silhouettes%2C%20professional%20television%20production%20set%2C%20cinematic%20wide%20shot%2C%20prestigious%20competition%20atmosphere&width=800&height=300&seq=trending-cover-voz&orientation=landscape',
        stats: [
          { label: 'Participantes', value: '3.4K' },
          { label: 'Premio', value: '$5,000' },
          { label: 'Score RFW', value: '97.8' },
        ],
        position: 1,
        trendDirection: 'up',
        trendValue: '+56.2%',
        score: 97.8,
        link: '/competencias',
        tags: ['Talento', 'Canto', 'Gran Premio'],
      },
      {
        id: 51,
        name: 'Trivia Maestra RFW',
        description: 'Demostrá cuánto sabés de radio. 100 preguntas, 4 categorías y un gran premio de $1,000 USD.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Quiz%20competition%20scene%20with%20warm%20lighting%2C%20question%20cards%2C%20buzzer%20buttons%2C%20game%20show%20atmosphere%2C%20intellectual%20challenge%2C%20editorial%20photography%2C%20rich%20amber%20tones%2C%20exciting%20moment&width=400&height=400&seq=trending-concurso-trivia&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Professional%20game%20show%20set%20with%20warm%20amber%20lighting%2C%20contestant%20podiums%2C%20large%20display%20screens%2C%20quiz%20atmosphere%2C%20television%20production%20quality%2C%20cinematic%20wide%20shot%2C%20competitive%20energy&width=800&height=300&seq=trending-cover-trivia&orientation=landscape',
        stats: [
          { label: 'Participantes', value: '5.8K' },
          { label: 'Premio', value: '$1,000' },
          { label: 'Score RFW', value: '94.3' },
        ],
        position: 2,
        trendDirection: 'up',
        trendValue: '+41.8%',
        score: 94.3,
        link: '/trivias',
        tags: ['Trivia', 'Conocimiento', 'Interactivo'],
      },
      {
        id: 52,
        name: 'Diseñá la Nueva Camiseta RFW',
        description: 'Tu diseño puede convertirse en la camiseta oficial de RFW para el 2026. Premio: $2,500 USD.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Creative%20design%20competition%20workspace%20with%20warm%20lighting%2C%20sketches%20and%20color%20swatches%2C%20artistic%20atmosphere%2C%20design%20tools%2C%20editorial%20photography%2C%20inspirational%20creative%20environment%2C%20rich%20warm%20tones&width=400&height=400&seq=trending-concurso-diseno&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Creative%20design%20studio%20with%20warm%20natural%20lighting%2C%20artwork%20displays%20on%20walls%2C%20modern%20workspace%2C%20colorful%20inspiration%20boards%2C%20professional%20creative%20environment%2C%20cinematic%20wide%20shot%2C%20artistic%20atmosphere&width=800&height=300&seq=trending-cover-diseno&orientation=landscape',
        stats: [
          { label: 'Participantes', value: '2.1K' },
          { label: 'Premio', value: '$2,500' },
          { label: 'Score RFW', value: '90.7' },
        ],
        position: 3,
        trendDirection: 'up',
        trendValue: '+33.4%',
        score: 90.7,
        link: '/competencias',
        tags: ['Diseño', 'Creativo', 'Merch'],
      },
      {
        id: 53,
        name: 'Reto Fitness con RFW',
        description: '30 días de entrenamiento con coaches profesionales. Premios semanales y gran premio final de $3,000 USD.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Fitness%20challenge%20competition%20with%20warm%20energetic%20lighting%2C%20workout%20equipment%2C%20motivational%20atmosphere%2C%20active%20lifestyle%2C%20editorial%20photography%2C%20dynamic%20composition%2C%20warm%20golden%20tones&width=400&height=400&seq=trending-concurso-fitness&orientation=squarish',
        coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20fitness%20studio%20with%20warm%20natural%20lighting%2C%20professional%20workout%20equipment%2C%20energetic%20atmosphere%2C%20large%20windows%20with%20sunlight%2C%20clean%20modern%20design%2C%20cinematic%20wide%20shot%2C%20motivational%20environment&width=800&height=300&seq=trending-cover-fitness&orientation=landscape',
        stats: [
          { label: 'Participantes', value: '4.2K' },
          { label: 'Premio', value: '$3,000' },
          { label: 'Score RFW', value: '92.6' },
        ],
        position: 4,
        trendDirection: 'up',
        trendValue: '+29.1%',
        score: 92.6,
        link: '/competencias',
        tags: ['Fitness', 'Reto', 'Salud'],
      },
    ],
  },
];

export const contentBlocks: ContentBlock[] = [
  {
    id: 'comentado',
    name: 'Más Comentado',
    icon: 'ri-chat-3-line',
    color: 'text-rose-600',
    description: 'El contenido que está generando más conversación y debate en la comunidad.',
    items: [
      {
        id: 101,
        title: '¿Cuál es la mejor radio del año?',
        description: 'Encuesta anual donde la comunidad vota por su emisora favorita. Más de 45,000 votos registrados.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Community%20voting%20poll%20with%20warm%20lighting%2C%20colorful%20ballot%20cards%2C%20engaged%20audience%2C%20democratic%20atmosphere%2C%20editorial%20photography%2C%20civic%20participation%20theme%2C%20rich%20warm%20tones%2C%20hands%20raised&width=400&height=300&seq=block-comentado-encuesta&orientation=landscape',
        metric: 'comentarios',
        metricValue: 12340,
        metricLabel: 'comentarios',
        position: 1,
        link: '/encuestas',
        category: 'Encuesta',
      },
      {
        id: 102,
        title: 'El Lobo entrevista al Presidente',
        description: 'La entrevista más polémica del año. El país entero debatiendo sobre cada respuesta.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20interview%20scene%20with%20warm%20dramatic%20lighting%2C%20two%20figures%20in%20conversation%2C%20serious%20journalistic%20atmosphere%2C%20professional%20studio%20setting%2C%20editorial%20photography%2C%20high%20stakes%20mood%2C%20rich%20contrast&width=400&height=300&seq=block-comentado-entrevista&orientation=landscape',
        metric: 'comentarios',
        metricValue: 9870,
        metricLabel: 'comentarios',
        position: 2,
        link: '/host/alejandro-el-lobo-mendoza',
        category: 'Entrevista',
      },
      {
        id: 103,
        title: 'Nuevo formato de La Mega: ¿Te gusta?',
        description: 'La Mega renovó su programación y la comunidad está dividida. Debate abierto en el foro.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Community%20forum%20debate%20with%20warm%20lighting%2C%20discussion%20atmosphere%2C%20diverse%20opinions%20represented%2C%20modern%20meeting%20space%2C%20editorial%20photography%2C%20engaged%20group%2C%20rich%20amber%20tones&width=400&height=300&seq=block-comentado-debate&orientation=landscape',
        metric: 'comentarios',
        metricValue: 8560,
        metricLabel: 'comentarios',
        position: 3,
        link: '/radio/la-mega-107-3',
        category: 'Debate',
      },
      {
        id: 104,
        title: 'Resultados Trivia Maestra: ¡Sorpresas!',
        description: 'Los resultados dejaron a todos con la boca abierta. Hubo empate en el primer lugar.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Exciting%20competition%20results%20announcement%20with%20warm%20lighting%2C%20surprised%20reactions%2C%20celebration%20moment%2C%20awards%20ceremony%20atmosphere%2C%20editorial%20photography%2C%20joyful%20expressions%2C%20golden%20tones&width=400&height=300&seq=block-comentado-resultados&orientation=landscape',
        metric: 'comentarios',
        metricValue: 7230,
        metricLabel: 'comentarios',
        position: 4,
        link: '/trivias',
        category: 'Resultados',
      },
    ],
  },
  {
    id: 'compartido',
    name: 'Más Compartido',
    icon: 'ri-share-forward-line',
    color: 'text-emerald-600',
    description: 'Lo que la comunidad está difundiendo en redes sociales, grupos de WhatsApp y más.',
    items: [
      {
        id: 201,
        title: 'Promo RFW Fest 2026: ¡Imperdible!',
        description: 'El video promocional del festival se volvió viral. Más de 250,000 reproducciones en 48 horas.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Exciting%20music%20festival%20promotional%20video%20frame%20with%20warm%20golden%20lighting%2C%20crowd%20energy%2C%20concert%20atmosphere%2C%20dynamic%20composition%2C%20editorial%20photography%2C%20vibrant%20celebration%2C%20rich%20warm%20tones&width=400&height=300&seq=block-compartido-promo&orientation=landscape',
        metric: 'compartidos',
        metricValue: 18450,
        metricLabel: 'veces compartido',
        position: 1,
        link: '/eventos',
        category: 'Video',
      },
      {
        id: 202,
        title: 'Valentina Ríos anuncia su embarazo al aire',
        description: 'El momento más emotivo del año. La locutora compartió la noticia con su audiencia en vivo.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Emotional%20announcement%20moment%20in%20radio%20studio%2C%20warm%20intimate%20lighting%2C%20genuine%20happiness%2C%20personal%20sharing%2C%20editorial%20photography%2C%20touching%20atmosphere%2C%20soft%20golden%20tones&width=400&height=300&seq=block-compartido-anuncio&orientation=landscape',
        metric: 'compartidos',
        metricValue: 15230,
        metricLabel: 'veces compartido',
        position: 2,
        link: '/host/valentina-rios',
        category: 'Momento',
      },
      {
        id: 203,
        title: 'Guía: Cómo armar tu propia radio online',
        description: 'Tutorial completo paso a paso. El artículo más guardado y compartido de la sección de ayuda.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20tutorial%20guide%20scene%20with%20warm%20lighting%2C%20laptop%20showing%20instructions%2C%20modern%20workspace%2C%20educational%20atmosphere%2C%20editorial%20photography%2C%20clean%20organized%20setup%2C%20soft%20warm%20tones&width=400&height=300&seq=block-compartido-guia&orientation=landscape',
        metric: 'compartidos',
        metricValue: 12980,
        metricLabel: 'veces compartido',
        position: 3,
        link: '/register-radio',
        category: 'Guía',
      },
      {
        id: 204,
        title: 'Playlist: Las 100 canciones del verano',
        description: 'La playlist curada por los locutores de RFW que todos están compartiendo en sus stories.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20music%20playlist%20concept%20with%20warm%20golden%20sunset%20lighting%2C%20headphones%20and%20music%20notes%2C%20beach%20atmosphere%2C%20relaxed%20vacation%20vibes%2C%20editorial%20photography%2C%20nostalgic%20warm%20tones%2C%20lifestyle%20shot&width=400&height=300&seq=block-compartido-playlist&orientation=landscape',
        metric: 'compartidos',
        metricValue: 11240,
        metricLabel: 'veces compartido',
        position: 4,
        link: '/favoritos',
        category: 'Playlist',
      },
    ],
  },
  {
    id: 'reaccionado',
    name: 'Más Reaccionado',
    icon: 'ri-emotion-line',
    color: 'text-amber-600',
    description: 'El contenido que más emociones está despertando: me gusta, me encanta, sorprendente y más.',
    items: [
      {
        id: 301,
        title: 'Ganador de La Voz de tu Ciudad: Presentación Final',
        description: 'La presentación que hizo llorar a todo el jurado. Una voz que nadie esperaba.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Emotional%20live%20performance%20with%20warm%20dramatic%20spotlight%2C%20singer%20on%20stage%2C%20captivated%20audience%2C%20powerful%20moment%2C%20editorial%20photography%2C%20intense%20atmosphere%2C%20rich%20golden%20lighting&width=400&height=300&seq=block-reaccion-presentacion&orientation=landscape',
        metric: 'reacciones',
        metricValue: 28900,
        metricLabel: 'reacciones',
        position: 1,
        link: '/competencias',
        category: 'Video',
      },
      {
        id: 302,
        title: 'Foto: El Lobo recibe premio a la trayectoria',
        description: 'La imagen del locutor recibiendo el galardón con lágrimas en los ojos conmovió a todos.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Touching%20award%20ceremony%20moment%2C%20warm%20golden%20lighting%2C%20emotional%20acceptance%2C%20prestigious%20atmosphere%2C%20editorial%20photography%2C%20heartfelt%20expression%2C%20soft%20rich%20tones%2C%20genuine%20moment&width=400&height=300&seq=block-reaccion-premio&orientation=landscape',
        metric: 'reacciones',
        metricValue: 24500,
        metricLabel: 'reacciones',
        position: 2,
        link: '/host/alejandro-el-lobo-mendoza',
        category: 'Foto',
      },
      {
        id: 303,
        title: 'Club Legión de la Mega llega a 12,000 miembros',
        description: 'Celebración comunitaria con mensajes de todos los miembros fundadores del club.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Community%20celebration%20moment%20with%20warm%20festive%20lighting%2C%20group%20of%20happy%20people%2C%20confetti%20atmosphere%2C%20achievement%20milestone%2C%20editorial%20photography%2C%20joyful%20energy%2C%20golden%20celebration%20tones&width=400&height=300&seq=block-reaccion-celebracion&orientation=landscape',
        metric: 'reacciones',
        metricValue: 19870,
        metricLabel: 'reacciones',
        position: 3,
        link: '/clubes',
        category: 'Celebración',
      },
      {
        id: 304,
        title: 'Noche de Leyendas: Especial The Beatles',
        description: 'El episodio más emotivo del programa. 4 horas dedicadas a la banda más grande de la historia.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%20tribute%20radio%20show%20atmosphere%20with%20warm%20amber%20lighting%2C%20vinyl%20records%2C%20vintage%20microphone%2C%20Beatles%20memorabilia%2C%20editorial%20photography%2C%20emotional%20tribute%20mood%2C%20rich%20golden%20tones&width=400&height=300&seq=block-reaccion-beatles&orientation=landscape',
        metric: 'reacciones',
        metricValue: 17650,
        metricLabel: 'reacciones',
        position: 4,
        link: '/program/noche-de-leyendas',
        category: 'Programa',
      },
    ],
  },
  {
    id: 'guardado',
    name: 'Más Guardado',
    icon: 'ri-bookmark-line',
    color: 'text-violet-600',
    description: 'Lo que la comunidad está guardando para ver después, escuchar de nuevo o no perderse.',
    items: [
      {
        id: 401,
        title: 'Calendario completo de eventos RFW 2026',
        description: 'Todas las fechas importantes del año: festivales, premiaciones, torneos y conciertos exclusivos.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Organized%20event%20calendar%20with%20warm%20lighting%2C%20marked%20dates%2C%20planning%20atmosphere%2C%20clean%20modern%20desk%20setup%2C%20editorial%20photography%2C%20productive%20workspace%2C%20soft%20warm%20tones&width=400&height=300&seq=block-guardado-calendario&orientation=landscape',
        metric: 'guardados',
        metricValue: 8920,
        metricLabel: 'veces guardado',
        position: 1,
        link: '/eventos',
        category: 'Calendario',
      },
      {
        id: 402,
        title: 'Tutorial: Cómo participar en concursos RFW',
        description: 'Guía completa para nuevos oyentes. Desde crear tu perfil hasta ganar tu primer concurso.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Helpful%20tutorial%20guide%20scene%20with%20warm%20lighting%2C%20laptop%20showing%20step%20by%20step%20instructions%2C%20welcoming%20atmosphere%2C%20educational%20content%2C%20editorial%20photography%2C%20clean%20organized%20workspace%2C%20soft%20amber%20tones&width=400&height=300&seq=block-guardado-tutorial&orientation=landscape',
        metric: 'guardados',
        metricValue: 7450,
        metricLabel: 'veces guardado',
        position: 2,
        link: '/competencias',
        category: 'Tutorial',
      },
      {
        id: 403,
        title: 'Entrevista completa: Diana Fuentes sin filtro',
        description: 'La locutora revela su historia, sus inicios y los secretos detrás del micrófono.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Intimate%20interview%20setting%20with%20warm%20soft%20lighting%2C%20two%20people%20in%20deep%20conversation%2C%20personal%20storytelling%20atmosphere%2C%20editorial%20photography%2C%20genuine%20connection%2C%20rich%20amber%20tones%2C%20cozy%20environment&width=400&height=300&seq=block-guardado-entrevista&orientation=landscape',
        metric: 'guardados',
        metricValue: 6890,
        metricLabel: 'veces guardado',
        position: 3,
        link: '/host/diana-fuentes',
        category: 'Entrevista',
      },
      {
        id: 404,
        title: 'Las 10 radios con mejor score RFW',
        description: 'Ranking actualizado semanalmente con análisis detallado de cada emisora.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20ranking%20list%20with%20warm%20lighting%2C%20data%20charts%20display%2C%20analytical%20atmosphere%2C%20modern%20office%20setup%2C%20editorial%20photography%2C%20information%20design%2C%20clean%20minimalist%20style%2C%20soft%20amber%20tones&width=400&height=300&seq=block-guardado-ranking&orientation=landscape',
        metric: 'guardados',
        metricValue: 6120,
        metricLabel: 'veces guardado',
        position: 4,
        link: '/rankings',
        category: 'Ranking',
      },
    ],
  },
  {
    id: 'visitado',
    name: 'Más Visitado',
    icon: 'ri-eye-line',
    color: 'text-sky-600',
    description: 'Las páginas y secciones que más tráfico están recibiendo en este momento.',
    items: [
      {
        id: 501,
        title: 'Perfil: La Mega 107.3 FM',
        description: 'La página de radio más visitada. Cifras récord de streaming en vivo y engagement.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Popular%20radio%20station%20profile%20page%20with%20warm%20amber%20lighting%2C%20modern%20web%20interface%2C%20streaming%20dashboard%2C%20professional%20broadcast%20atmosphere%2C%20editorial%20photography%2C%20digital%20content%20display%2C%20rich%20warm%20tones&width=400&height=300&seq=block-visitado-mega&orientation=landscape',
        metric: 'visitas',
        metricValue: 347800,
        metricLabel: 'visitas esta semana',
        position: 1,
        link: '/radio/la-mega-107-3',
        category: 'Radio',
      },
      {
        id: 502,
        title: 'Rankings RFW Globales',
        description: 'La página más consultada para ver quién lidera en cada categoría del ecosistema.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Global%20rankings%20dashboard%20with%20warm%20lighting%2C%20leaderboard%20display%2C%20competitive%20atmosphere%2C%20data%20visualization%2C%20editorial%20photography%2C%20modern%20digital%20interface%2C%20clean%20professional%20look%2C%20amber%20tones&width=400&height=300&seq=block-visitado-rankings&orientation=landscape',
        metric: 'visitas',
        metricValue: 289400,
        metricLabel: 'visitas esta semana',
        position: 2,
        link: '/rankings',
        category: 'Página',
      },
      {
        id: 503,
        title: 'Centro de Gamificación',
        description: 'Cada vez más oyentes descubren el sistema de niveles, misiones y recompensas.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Interactive%20gamification%20dashboard%20with%20warm%20lighting%2C%20achievement%20badges%20display%2C%20progress%20tracking%2C%20engaging%20game-like%20interface%2C%20editorial%20photography%2C%20modern%20digital%20experience%2C%20rich%20vibrant%20tones&width=400&height=300&seq=block-visitado-gamificacion&orientation=landscape',
        metric: 'visitas',
        metricValue: 215600,
        metricLabel: 'visitas esta semana',
        position: 3,
        link: '/gamificacion',
        category: 'Sección',
      },
      {
        id: 504,
        title: 'Perfil de Valentina Ríos',
        description: 'El perfil de locutor más visitado. Su comunidad no para de crecer.',
        imageUrl: 'https://readdy.ai/api/search-image?query=Popular%20radio%20host%20profile%20page%20with%20warm%20lighting%2C%20modern%20clean%20design%2C%20social%20media%20style%20interface%2C%20editorial%20photography%2C%20engaging%20content%20display%2C%20professional%20yet%20approachable%2C%20soft%20golden%20tones&width=400&height=300&seq=block-visitado-valentina&orientation=landscape',
        metric: 'visitas',
        metricValue: 198300,
        metricLabel: 'visitas esta semana',
        position: 4,
        link: '/host/valentina-rios',
        category: 'Perfil',
      },
    ],
  },
];

export const socialCenterDashboardStats = {
  totalTrendingItems: 15689,
  activeCategories: 6,
  totalContentBlocks: 5,
  totalEngagementActions: 847200,
  trendingThisWeek: 4320,
  avgTrendScore: 93.8,
  mostActiveCategory: 'Radios',
  mostActiveCategoryCount: 3847,
  updatedMinutesAgo: 3,
};

export const socialCenterRules = [
  {
    icon: 'ri-refresh-line',
    title: 'Actualización Automática',
    description: 'Todo el contenido del Centro Social se actualiza automáticamente según la actividad real de la comunidad. Cada like, comentario, compartir y visita modifica los rankings en tiempo real.',
  },
  {
    icon: 'ri-fire-line',
    title: 'Tendencia Real',
    description: 'Lo que ves en tendencia es lo que realmente está pasando. No hay curaduría manual — el algoritmo detecta picos de actividad y los refleja al instante.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Transparencia Total',
    description: 'Cada métrica que mostramos tiene una fuente clara. Sabés exactamente por qué algo está en tendencia y podés ver los datos que lo respaldan.',
  },
];

export const livePulseItems = [
  { label: 'Oyentes Conectados', value: '47,892', icon: 'ri-headphone-line', color: 'text-emerald-600', bgColor: 'bg-emerald-50' },
  { label: 'Radios Al Aire', value: '234', icon: 'ri-radio-line', color: 'text-rose-600', bgColor: 'bg-rose-50' },
  { label: 'Programas Activos', value: '189', icon: 'ri-mic-line', color: 'text-amber-600', bgColor: 'bg-amber-50' },
  { label: 'Interacciones Hoy', value: '1.2M', icon: 'ri-flashlight-line', color: 'text-violet-600', bgColor: 'bg-violet-50' },
  { label: 'Nuevos Posts', value: '3,456', icon: 'ri-article-line', color: 'text-sky-600', bgColor: 'bg-sky-50' },
  { label: 'Concursos Abiertos', value: '78', icon: 'ri-trophy-line', color: 'text-orange-600', bgColor: 'bg-orange-50' },
];

export function getHighestTrendingItem(): TrendingItem {
  let highest: TrendingItem | null = null;
  for (const cat of trendingCategories) {
    for (const item of cat.items) {
      if (!highest || item.score > highest.score) {
        highest = item;
      }
    }
  }
  return highest!;
}

export function getCategoryById(id: string): TrendingCategory | undefined {
  return trendingCategories.find((cat) => cat.id === id);
}

export function getBlockById(id: string): ContentBlock | undefined {
  return contentBlocks.find((block) => block.id === id);
}